import { FC, useEffect, useMemo, useState } from 'react'

import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { locationEvent, pageViewEvent } from 'src/Helpers/TagManager'
import { setRequirementsToInitialState } from 'src/Redux/wise-process'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { getUserId } from 'src/Redux/auth-process/userSlice/selectors'
import {
  getIsArtist,
  getUserRole,
} from 'src/Redux/auth-process/credentialsSlice/selectors'
import { pageInfo } from 'src/Helpers/TagManager/pageInfo'
import { PrimaryTabs } from 'src/Components/PrimaryTabs'

import { TabKeys, getTabs } from './halpers'
import { SettingsTabs } from './components/SettingsTabs'

import { SettingsPageContainer, SettingsInnerContainer, Title } from './styles'

const getActiveTabByPage = (
  page: string | undefined,
  isArtist: boolean,
): TabKeys => {
  if (page === 'email') {
    return TabKeys.email
  }

  if (page === 'payout') {
    return TabKeys.payout
  }

  return isArtist ? TabKeys.password : TabKeys.payout
}

export const SettingsPage: FC = () => {
  const { page } = useParams()

  const dispatch = useAppDispatch()
  const userID = useAppSelector(getUserId)
  const userRole = useAppSelector(getUserRole)
  const isArtist = useSelector(getIsArtist)

  const [localActiveTab, setLocalActiveTab] = useState<TabKeys>()

  const activeTab =
    localActiveTab ?? getActiveTabByPage(page, Boolean(isArtist))

  useEffect(() => {
    pageViewEvent({ userID, currentPageInfo: pageInfo.settings })
    locationEvent()

    return () => {
      dispatch(setRequirementsToInitialState())
    }
  }, [userID, userRole, isArtist, page, dispatch])

  const tabItems = useMemo(
    () =>
      getTabs(Boolean(isArtist)).map((item) => ({
        label: item.title,
        key: item.key,
        children: <SettingsTabs active={item.key} />,
      })),
    [isArtist],
  )

  return (
    <SettingsPageContainer>
      <Title>Settings</Title>

      <SettingsInnerContainer>
        <PrimaryTabs
          activeKey={activeTab}
          defaultActiveKey={getActiveTabByPage(page, Boolean(isArtist))}
          items={tabItems}
          onChange={(activeKey) => setLocalActiveTab(activeKey as TabKeys)}
        />
      </SettingsInnerContainer>
    </SettingsPageContainer>
  )
}
